import React, { ReactElement, useState } from 'react';
import { DdElementGroupType } from '../../../types/importtypes';
import HeaderTitle from '../../modularcomponents/header/headertitle';
import HeaderProperty from '../../modularcomponents/header/headerproperty';
import HeaderPropertyName from '../../modularcomponents/header/headerpropertyname';
import HeaderPropertyValue from '../../modularcomponents/header/headerpropertyvalue';
import HeaderContainer from '../../modularcomponents/header/headercontainer';
import HeaderItems from '../../modularcomponents/header/headeritems';
import HeaderItem from '../../modularcomponents/header/headeritem';
import HeaderButtons from '../../modularcomponents/header/headerbuttons';
import { DdElementGroupsService } from '../../../services/import';
import VersionsSubHeader from '../VersionsSubHeader';
import HeaderSummary from '../../modularcomponents/header/headersummary';

function DdElementGroupHeader(props: {ddElementGroup: DdElementGroupType}): ReactElement {
  const active = `${props.ddElementGroup.versionManagement.active}`;
  const [expand, setExpand] = useState(false);

  const toggleExpand = () => {
    setExpand(val => !val);
  };

  return (
    <HeaderContainer expanded={expand} setExpanded={setExpand}>
      <HeaderSummary toggleExpand={toggleExpand}>
        <HeaderTitle toggleExpand={toggleExpand} type='' name={props.ddElementGroup.title} />
        <HeaderButtons id={props.ddElementGroup._id} service={new DdElementGroupsService()} actionList={[]} />
      </HeaderSummary>
      <HeaderItems>
        <HeaderItem>
          <HeaderProperty>
            <HeaderPropertyName name='Full Ref' />
            <HeaderPropertyValue>
              {props.ddElementGroup.fullRef}
            </HeaderPropertyValue>
          </HeaderProperty>

          <HeaderProperty>
            <HeaderPropertyName name='Simple Id' />
            <HeaderPropertyValue>
              {props.ddElementGroup.versionManagement.simpleId}
            </HeaderPropertyValue>
          </HeaderProperty>

          <HeaderProperty>
            <HeaderPropertyName name='Version' />
            <HeaderPropertyValue>
              {props.ddElementGroup.versionManagement.version.toString()}
            </HeaderPropertyValue>
          </HeaderProperty>

          <HeaderProperty>
            <HeaderPropertyName name='Active' />
            <HeaderPropertyValue>
              {active.charAt(0).toUpperCase() + active.slice(1)}
            </HeaderPropertyValue>
          </HeaderProperty>
        </HeaderItem>
      </HeaderItems>
      <VersionsSubHeader<DdElementGroupType> id={props.ddElementGroup._id} service={new DdElementGroupsService()} />
    </HeaderContainer>
  );
}

export default DdElementGroupHeader;
